/**
 * ``account.*`` event schemas — personal-preferences surface.
 *
 * All ``account.*`` events are frontend-emitted (the settings page is
 * a pure UI surface; the backend writes the preferences but doesn't
 * capture analytics for them).
 *
 * Source of truth: ``plans/PLAN_POSTHOG_02_EVENT_CATALOG.md`` §
 * "account.*".
 */

import { z } from "zod";

import { BaseEventSchema } from "./base";
import { AccountSettingsFieldProperty } from "./properties";

export const AccountSettingsViewedSchema = BaseEventSchema.extend({
  event_name: z.literal("account.settings.viewed"),
  screen: z.string(),
});

export const AccountSettingsSavedSchema = BaseEventSchema.extend({
  event_name: z.literal("account.settings.saved"),
  changed_fields: z.array(AccountSettingsFieldProperty).min(1),
});

export const AccountSecurityViewedSchema = BaseEventSchema.extend({
  event_name: z.literal("account.security.viewed"),
  screen: z.string(),
});

export const accountEvents = [
  AccountSettingsViewedSchema,
  AccountSettingsSavedSchema,
  AccountSecurityViewedSchema,
] as const;
